// 科研接口三元组字段：head 头实体、headType 头实体类型、relation 关系、
// tail 尾实体、tailType 尾实体类型，均为必需字段。
const toText = (value) => (value === null || value === undefined ? '' : String(value).trim());

export function parseResearchTriples(value) {
    const rows = [];
    // 接口返回对象数组：[{ head, headType, relation, tail, tailType }]
    if (Array.isArray(value)) {
        value.forEach((item) => {
            if (!item) return;
            const head = toText(item.head);
            const relation = toText(item.relation);
            const tail = toText(item.tail);
            if (!head || !relation || !tail) return;
            rows.push({
                head,
                headType: toText(item.headType),
                relation,
                tail,
                tailType: toText(item.tailType),
            });
        });
        return rows;
    }
    // 兼容字符串格式：头实体:头实体类型:关系:尾实体:尾实体类型;
    if (typeof value === 'string') {
        value.split(';').forEach((entry) => {
            const fields = entry.split(':').map((field) => field.trim());
            if (fields.length !== 5 || !fields.every(Boolean)) return;
            const [head, headType, relation, tail, tailType] = fields;
            rows.push({ head, headType, relation, tail, tailType });
        });
    }
    return rows;
}

// 图谱与三元组列表使用接口返回的两套独立字段：如图谱 caseReportGraph、三元组 caseReportTriple。
export function getResearchGraph(data, graphField, tripleField) {
    const graph = (data && data[graphField]) || {};
    return {
        nodes: Array.isArray(graph.nodes) ? graph.nodes : [],
        edges: Array.isArray(graph.edges) ? graph.edges : [],
        triples: parseResearchTriples(data && data[tripleField]),
    };
}

// 疾病名称取自接口返回的 data.diseaseName。
export function getResearchDiseaseName(data) {
    return (data && data.diseaseName) || '';
}

export function getResearchLiterature(data) {
    const groups = (data && data.literatureList) || {};
    return Object.keys(groups).reduce((rows, category) => {
        if (!Array.isArray(groups[category])) return rows;
        return rows.concat(groups[category].filter(Boolean).map((item) => ({
            id: `${category}-${item['序号']}`,
            title: item['标题'] || '',
            abstract: item['摘要'] || '',
            category,
        })));
    }, []);
}
